import type { AnimationControls, AnimationDefinition } from "framer-motion";

export type AnimatedIconProps = React.SVGAttributes<SVGSVGElement> & {
  controls: AnimationControls;
  onAnimationComplete?: (definition: AnimationDefinition) => void;
};
